import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from '@/locales/en/translation.json';
import ptTranslation from '@/locales/pt/translation.json';
import frTranslation from '@/locales/fr/translation.json';
import swTranslation from '@/locales/sw/translation.json';
import esTranslation from '@/locales/es/translation.json';
import arTranslation from '@/locales/ar/translation.json';

const resources = {
  en: { translation: enTranslation },
  pt: { translation: ptTranslation },
  fr: { translation: frTranslation },
  sw: { translation: swTranslation },
  es: { translation: esTranslation },
  ar: { translation: arTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// RTL support, Arabic is the only RTL locale among the 6 supported languages.
const RTL_LANGUAGES = ['ar'];
const applyDirection = (lng: string) => {
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
};
applyDirection(i18n.resolvedLanguage ?? i18n.language ?? 'en');
i18n.on('languageChanged', applyDirection);

export default i18n;
